import { WorkflowSelectV2 } from '@frontend/workflow/select';
import { WorkflowType } from '@frontend/workflow/types';

export interface PackageWorkflowFieldProps {
    onChange: (value: string | null) => void;
    value: string | null;
    disabled?: boolean;
    className?: string;
    label?: React.ReactNode;
    required?: boolean;
    options?: string[];
}

export const PackageWorkflowField = (props: PackageWorkflowFieldProps) => {
    return (
        <WorkflowSelectV2
            {...props}
            label={props.label || 'Package Workflow'}
            queryParams={{ type: WorkflowType.PACKAGE }}
            isClearable
        />
    );
};
